import { VerticalFlex } from '@eversports/react-components/primitives/Flex'
import Heading from '@eversports/react-components/primitives/Heading'
import Text from '@eversports/react-components/primitives/Text'
import { Localized } from '../../localization/react'

function AccessDeniedMessage() {
  return (
    <VerticalFlex
      verticalSpacing="default"
      style={{ maxWidth: 600, margin: '0 auto', padding: 24, textAlign: 'center' }}
    >
      <Heading is="h1" variant="large" color="danger">
        <Localized id="access-denied-heading" />
      </Heading>
      <Text color="muted">
        <Localized id="access-denied-message" />
      </Text>
    </VerticalFlex>
  )
}

export { AccessDeniedMessage }
